import '../common/setup-globals';
import { manageSessions } from '../common/manageSessions';
//import { initGa } from '../common/analytics';

// Example of using expose-loader to expose a function to the global scope. However this exposed the entire analytics module, not just the function.
// so I moved this function to setup-globals.js instead
//import trackGoogleEvent from 'expose-loader?exposes=trackGoogleEvent!../common/analytics.js';

const sessionData = manageSessions();
//initGa(sessionData);

